import React, { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import {BrowserRouter as Router, Routes,Route} from 'react-router-dom'
import { Link,useNavigate,useLocation } from 'react-router-dom';
import axios from 'axios'; 
import useAuth from '../hooks/useAuth';
import {useForm} from 'react-hook-form';
import {DevTool} from '@hookform/devtools'
// Config
import { 
  EMPLOYEES_BASE_URL,
 

 } from '../config';
// Components
import Knoppie from './Knoppie'
import Header from './Header'
import Home from './Home';
import Thumb from './Thumb';

// Hook

// Image

let renderCount = 0

const NewEmployee = () => {
  
  const auth = useAuth();
  const{clubid}=useParams()
  console.log(clubid)
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || "/";
  
  const form = useForm()
  const {register, control, handleSubmit, formState} = form
  const {errors} = formState
  
  const [errMessage,setErrMessage] = useState("");
  const [success, setSuccess]= useState(false);
  const username = auth.auth.user.username
  const access = auth.auth.user.userRole
  const accessToken = auth.auth.accessToken
  
  const onSubmit = async data => {
     
      console.log("Form Submitted",data)

      try {
        const response =  await axios.post(`${EMPLOYEES_BASE_URL}`,
          JSON.stringify({data:data}),
          {
            headers: {
              'Content-Type': 'application/json',
              'authorization': 'Bearer '+accessToken

            }
          }
        );
       
        navigate(from, {replace: true});

      } catch (error) {

        if(!error.response){
          setErrMessage("No server response")
        }else if (error.response?.status === 400){
          setErrMessage("Missing data")
        }else if (error.response?.status === 500){
          
          setErrMessage(error.response?.data.msg.message)
        } else {
          setErrMessage('failed')
        }
        console.log(error)
      }
      
      
    }
    renderCount++
  return (
    <>
    <h1>RenderCount {renderCount/2}</h1>
    <Header username={username} role={access} Login={false}></Header>
    <Knoppie
      destination={"/"}
      text={'Back'}
      clickable
      />
      
 <section>

<p >
{errMessage}
</p>
</section>
      <form  onSubmit={handleSubmit(onSubmit)} noValidate className="FormClass">
        
      <h1>Add new Employee:</h1>
      <div className='Lineitem'>
      <label>Employee Code</label>
      <input className="inputsize" type={"text"} {...register('employee',{
        required:'employee code is required'
      })}/>
      <p className='error'>{errors.employee?.message}</p>
      </div>
      <div className='Lineitem'>
      <label>Employee name</label>
          <input className="inputsize" type={"text"}  {...register('givname',{
            required:'name is required'
          })}/>
<p className='error'>{errors.givname?.message}</p>
      </div>
      <div className='Lineitem'>
          <label>Employee surname</label> 
          <input className="inputsize" type={"text"} {...register('surname',{
            required:'surname is required'
          })}/>
<p className='error'>{errors.surname?.message}</p>
      </div>
      <div className='Lineitem'>
          <label>Employee group</label> 
          <input className="inputsize" type={"text"} {...register('group')}/>
        
      </div>
      <div className='Lineitem'>
          <label>Employee dept</label> 
          <input className="inputsize" type={"text"} {...register('dept')}/>
        
      </div>
      <div className='Lineitem'>
          <label>Employee title</label> 
          <input className="inputsize" type={"text"} {...register('title')}/>
        
      </div>
      <div className='Lineitem'>
          <label>Employee adr1</label> 
          <input className="inputsize" type={"text"} {...register('adr1')}/>
        
      </div>
      <div className='Lineitem'>
          <label>Employee adr2</label> 
          <input className="inputsize" type={"text"} {...register('adr2')}/>
        
      </div>
      <div className='Lineitem'>
          <label>Employee adr3</label> 
          <input className="inputsize" type={"text"} {...register('adr3')}/>
        
      </div>
      <div className='Lineitem'>
          <label>Employee pcode</label> 
          <input className="inputsize" type={"text"} {...register('pcode')}/>
        
      </div>
      <div className='Lineitem'>
          <label>Employee phone</label> 
          <input className="inputsize" type={"number"} {...register('phone')}/>
        
      </div>
      <div className='Lineitem'>
          <label>Employee sdate</label> 
          <input className="inputsize" type={"date"} {...register('sdate')}/>
        
      </div>
      <div className='Lineitem'>
          <label>Employee baserate</label> 
          <input className="inputsize" type={"text"} {...register('baserate')}/>
        
      </div>
      <div className='Lineitem'>
          <label>Employee holrule</label> 
          <input className="inputsize" type={"text"}{...register('holrule')}/>
        
      </div>
      <div className='Lineitem'>
          <label>Employee sicrule</label> 
          <input className="inputsize" type={"text"} {...register('sicrule')}/>
        
      </div>
      
      <div className='Lineitem'>
          <label>Employee termdate</label> 
          <input className="inputsize" type={"date"} {...register('termdate')}/>
        
      </div>
      <div className='Lineitem'>
          <label>Employee position</label> 
          <input className="inputsize" type={"text"}{...register('position')}/>
        
      </div>
      <div className='Lineitem'>
          <label>Employee identity</label> 
          <input className="inputsize" type={"id"} {...register('identity')}/>
        
      </div>
      <div className='Lineitem'>
          <label>Employee incometax</label> 
          <input className="inputsize" type={"text"} {...register('incometax')}/>
        
      </div>
      <div className='Lineitem'>
          <label>Employee dob</label> 
          <input className="inputsize" type={"text"} {...register('dob')}/>
        
      </div>
      <div className='Lineitem'>
          <label>Employee active</label> 
          <input className="inputsize" type={"text"} value="true" {...register('active')}/>
        
      </div>
      <div className='Lineitem'>
          <label>Employee gender</label> 
          <input className="inputsize" type={"text"} {...register('gender')}/>
        
      </div>
      <div className='Lineitem'>
          <label>Employee race</label> 
          <input className="inputsize" type={"text"} {...register('race')}/>
        
      </div>
      <div className='Lineitem'>
          <label>Employee disability</label> 
          <input className="inputsize" type={"text"} {...register('disability')}/>
        
      </div>
      <div className='Lineitem'>
          <label>Employee foreignNational</label> 
          <input className="inputsize" type={"text"} {...register('foreignNational')}/>
        
      </div>
      <div className='Lineitem'>
          <label>Employee emailaddress</label> 
          <input className="inputsize" type={"text"} {...register('emailaddress',{
            pattern:{
              value: /^((?!\.)[\w\-_.]*[^.])(@\w+)(\.\w+(\.\w+)?[^.\W])$/gm,
              message:"email validation failed"
            }
          })}/>    
        
      </div>
             
          
          
          <button>Submit</button>
      </form>

      <DevTool control={control}/>
      
      </>
  )
};

export default NewEmployee;
